const datatable = {
  root: {
    background: '{white}',
    transitionDuration: '{transition.duration}',
    lineHeight: '1.2',
    disabledRowColor: '{text.disabled.color}',
  },
  header: {
    background: '{white}',
    border: 'none',
    borderColor: 'transparent',
    borderRadius: '0.25rem',
    color: '{content.color}',
    padding: '16px 24px',
  },
  headerCell: {
    borderBottom: '1px solid #ced5de',
    borderTop: '1px solid #ced5de',
    background: 'white',
    borderColor: '#ced5de',
    hoverBackground: 'white',
    selectedBackground: 'white',
    color: '{main}',
    hoverColor: '{main}',
    selectedColor: '{main}',
    gap: '0.5rem',
    padding: '12px 16px',
    fontSize: '12px',
    justifyContent: 'space-between',
  },
  actionBar: {
    padding: '0 16px',
    height: '40.3984px',
  },
  columnTitle: {
    fontWeight: '600',
    fontSize: '12px',
  },
  row: {
    background: 'white',
    hoverBackground: '#fafafa',
    selectedBackground: 'rgba(36, 112, 175, 0.1019607843)',
    color: '{main}',
    selectedColor: '{main}',
  },
  bodyCell: {
    borderColor: '#ced5de',
    fontSize: '14px',
    padding: '12px 16px',
    edit: {
      actionButton: {
        height: '0.5rem',
      },
      padding: '2px 16px',
    },
  },
  footerCell: {
    background: '{content.background}',
    borderColor: '{datatable.border.color}',
    color: '{content.color}',
    padding: '0.75rem 1rem',
  },
  columnFooter: {
    fontWeight: '600',
  },
  footer: {
    background: 'white',
    color: '{content.color}',
    borderWidth: '0 0 0 0',
    padding: '16px 24px',
  },
  dropPointColor: '{primary.color}',
  columnResizerWidth: '0.5rem',
  resizeIndicator: {
    width: '1px',
    color: '{primary.color}',
  },
  sortIcon: {
    color: '#b3b3b3',
    hoverColor: 'gray',
    activeColor: 'black',
    size: '12px',
    cursor: 'pointer',
  },
  loadingIcon: {
    size: '2rem',
  },
  columnExpander: {
    size: '56px',
  },
  columnSelector: {
    size: '56px',
  },
  colorScheme: {
    light: {
      root: {
        borderColor: '{content.border.color}',
      },
      row: {
        stripedBackground: '{surface.50}',
      },
      bodyCell: {
        selectedBorderColor: '#ced5de',
      },
    },
    dark: {
      root: {
        borderColor: '{surface.800}',
      },
      row: {
        stripedBackground: '{surface.950}',
      },
      bodyCell: {
        selectedBorderColor: '{primary.900}',
      },
    },
  },
};

export default datatable;
